var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "relative"
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "z-index": "2",
      "left": "15.53%",
      "top": "6.3%",
      "width": "70.14%",
      "aspect-ratio": "16 / 9",
      "background-color": "#000"
    }
  }, [_vm._t("default")], 2), _c('img', {
    staticStyle: {
      "position": "relative",
      "z-index": "1",
      "pointer-events": "none",
      "aspect-ratio": "1186 / 544"
    },
    attrs: {
      "width": "100%",
      "src": "https://cdn.ellacard.com/start/laptop-outline.png"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }